import React from "react";
import PageLayout from "./PageLayout";
import ReviewsSection from "./ReviewsSection";
import usePageMeta from "../hooks/usePageMeta";

const ReviewsPage = () => {
  usePageMeta({
    title: "Reseñas de clientes | RG Servicio Técnico",
    description:
      "Opiniones reales y testimonios destacados de clientes sobre nuestros servicios.",
    canonical: "https://rgserviciotecnico.com/resenas"
  });

  return (
    <PageLayout className="bg-background">
      <ReviewsSection />
    </PageLayout>
  );
};

export default ReviewsPage;
